import {AfterViewInit, Component, Inject, Input, OnInit, ViewChild, ViewEncapsulation, Injectable} from '@angular/core';
import {MainService} from '../../_services/main.service';
import {Grievance} from '../../_services/_modals/grievance.modal';
import {UtilService} from '../../../common/_services/util.service';
import {MatPaginator} from '@angular/material';
import {GrievanceListComponent} from '../grievance-list/grievance-list.component';
import {HttpService} from '../../../common/_services/http.service';
import {AppChannelComponent} from "../app-channel/app-channel.component";

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.css'],
    encapsulation: ViewEncapsulation.None

})
export class MainComponent implements AfterViewInit, OnInit {
    @ViewChild('mnewspub') mnewspub: GrievanceListComponent;
    @ViewChild('mnewsunm') mnewsunm: GrievanceListComponent;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @Input()
    ai_id: string;
    @Input()
    mod_callerid: string;
    @Input()
    public channel: string;
    @Input()
    ai_general: any;
    @Input()
    public rejectionReason: any;
    elastic_response = {};
    state = 'UNM';
    color = 'primary';
    value = 50;
    is_spinner_visible = true;
    item: any;
    public tabIndex = 0;
    public item_table_data: any;
    pub_list = [];
    unm_items = [];
    pub_items = [];
    search_items = [];
    search_spinner = false;
    states = [
        {id: 'PUB', name: 'Published'},
        {id: 'UNM', name: 'Unmoderated'},
        {id: 'ARC', name: 'Archived'},
        {id: 'REJ', name: 'Rejected'}
    ];

    autostates = [
        {id: 'autopub', name: 'AutoPUB'},
        {id: 'autorej, mlautorej', name: 'AutoREJ'},
        {id: 'followup', name: 'FollowUP'},
        {id: 'grievance', name: 'Grievance'},
    ];
    elastic_item = [];

    searchFields = {
                        states: null,
                        auto_state: null,
                        item_id: null,
                        tags: null,
                        ai_id: '',
                        start_date: null,
                        end_date: null,
                        callerId: null
                    };

    constructor(private mainService: MainService,
                private utilService: UtilService,
                private httpService: HttpService,
                private appChannelComponent: AppChannelComponent) {}

    async ngOnInit() {
        this.is_spinner_visible = true;
        this.item_table_data = await this.httpService.getItem_UNM(this.ai_id, this.channel, 'UNM');
        this.unm_items = this.item_table_data.Items;
       let item = await this.httpService.getGeneral(this.ai_id);
       if (item.Items[0]['publistCh' + this.channel]) {
           this.pub_list = item.Items[0]['publistCh' + this.channel];
           let pub_list_order = [];
           for (let i = 0; i < 20; i++) {
               if (this.pub_list[i]) {
                   pub_list_order.push(this.pub_list[i]);
               } else
                   break;
           }
           if (pub_list_order.length > 0) {
               this.item = await this.httpService.getBatchData(pub_list_order, this.ai_id, this.channel);
               let pub_list = [];
               pub_list_order.filter(value1 => {
                   this.item.Responses.Items.filter(value2 => {
                       if (value1 === value2.id) {
                           pub_list.push(value2);
                       }
                   });
               });
               this.pub_items = pub_list;
           }
       }
       this.is_spinner_visible = false;
    }

    ngAfterViewInit(): void {}
    init() {}

    tabClick(tab) {
        this.mnewspub.tabtoggle();
    }

    openTab(Tab) {
        this.tabIndex = Tab.index;
    }

    async elasticsearch() {
        this.search_spinner = true;
        if (this.searchFields.item_id) {
                this.elastic_item = [];
                this.searchFields.item_id = this.searchFields.item_id.replace(' ' , '');
                this.elastic_item = this.searchFields.item_id.split(',');
                const pub_list_order = [];
                for (let i = 0; i < 20; i++) {
                    if (this.elastic_item[i]) {
                        pub_list_order.push(this.elastic_item[i]);
                    } else {
                        break;
                    }
                }
                if (pub_list_order.length > 0) {
                    this.item = await this.httpService.getBatchData(pub_list_order, this.ai_id, this.channel);
                    this.search_items = this.item.Responses.Items;
                    this.search_spinner = false;
                }
        } else {
            this.search_spinner = true;
            this.searchFields.ai_id = this.ai_id;
            this.httpService.ElasticSearch(this.searchFields)
                .subscribe(async (response: any[]) => {
                    this.elastic_item = [];
                    this.elastic_response = response;
                    for (let i of this.elastic_response['hits'].hits) {
                        this.elastic_item.push(i._source.skey);
                    }
                    let pub_list_order = [];
                    for (let i = 0; i < 20; i++) {
                        if (this.elastic_item[i])
                            pub_list_order.push(this.elastic_item[i]);
                        else
                            break;
                    }
                    if (pub_list_order.length > 0) {
                        this.item = await this.httpService.getBatchData(pub_list_order, this.ai_id, this.channel);
                        let pub_list = [];
                        pub_list_order.filter(value1 => {
                            this.item.Responses.Items.filter(value2 => {
                                if (value1 === value2.id) {
                                    pub_list.push(value2);
                                }
                            });
                        });
                        this.search_items = pub_list;
                    } else {
                        this.search_items = [];
                    }
                    this.search_spinner = false;
                });
        }
    }
}
